import { render } from "./material-icon.vue?vue&type=template&id=327e1bb6&scoped=true&ts=true"
import script from "./material-icon.vue?vue&type=script&lang=ts"
export * from "./material-icon.vue?vue&type=script&lang=ts"

import "./material-icon.vue?vue&type=style&index=0&id=327e1bb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327e1bb6"]])

export default __exports__